/**
 * Día y vista del calendario: la URL manda; si no hay, lo último que se miró.
 */
import { hoyISO } from '../routes/calendario-fechas'

export type VistaCalendario = 'dia' | 'semana' | 'mes'

function claveVista(accountId: string): string {
    return `calendario:vista:${accountId}`
}
function claveDia(accountId: string): string {
    return `calendario:dia:${accountId}`
}

function esVista(v: string | null): v is VistaCalendario {
    return v === 'dia' || v === 'semana' || v === 'mes'
}

function esDia(v: string | null): v is string {
    return Boolean(v && /^\d{4}-\d{2}-\d{2}$/.test(v))
}

export function leerVistaCalendario(params: URLSearchParams, accountId: string | undefined): VistaCalendario {
    const q = params.get('vista')
    if (esVista(q)) return q
    if (!accountId) return 'dia'
    try {
        const g = localStorage.getItem(claveVista(accountId))
        if (esVista(g)) return g
    } catch {
        /* modo privado */
    }
    return 'dia'
}

export function leerDiaCalendario(params: URLSearchParams, accountId: string | undefined): string {
    const q = params.get('dia')
    if (esDia(q)) return q
    if (accountId) {
        try {
            const g = localStorage.getItem(claveDia(accountId))
            if (esDia(g)) return g
        } catch {
            /* modo privado */
        }
    }
    return hoyISO()
}

export function recordarCalendario(accountId: string, vista: VistaCalendario, dia: string): void {
    try {
        localStorage.setItem(claveVista(accountId), vista)
        localStorage.setItem(claveDia(accountId), dia)
    } catch {
        /* modo privado */
    }
}

/** Cómo se mira el mes en el teléfono (020 · FR-014). El monitor es cuadrícula. */
export type FormaMes = 'lista' | 'cuadricula'

export const CLAVE_FORMA_MES = 'agendify.calendario.formaMes'

export function leerFormaMes(): FormaMes {
    try {
        const g = localStorage.getItem(CLAVE_FORMA_MES)
        if (g === 'lista' || g === 'cuadricula') return g
    } catch {
        /* modo privado */
    }
    return 'lista'
}

export function recordarFormaMes(v: FormaMes): void {
    try {
        localStorage.setItem(CLAVE_FORMA_MES, v)
    } catch {
        /* modo privado */
    }
}

/** Spec 044 · FR-006. Por negocio: incluir en el recuento las citas ya empezadas. */
function claveIncluirPasadas(accountId: string): string {
    return `calendario:incluirPasadas:${accountId}`
}

export function leerIncluirPasadas(accountId: string | undefined): boolean {
    if (!accountId) return false
    try {
        return localStorage.getItem(claveIncluirPasadas(accountId)) === '1'
    } catch {
        return false
    }
}

export function recordarIncluirPasadas(accountId: string, v: boolean): void {
    try {
        localStorage.setItem(claveIncluirPasadas(accountId), v ? '1' : '0')
    } catch {
        /* modo privado */
    }
}
